<template>
  <v-dialog v-model="isOpenModal" max-width="700" persistent>
    <v-card class="pt-3 tw-px-5" id="edit-company">
      <v-card-title class="tw-pl-4">
        <div class="tw-text-xl tw-font-bold">แก้ไขข้อมูลบริษัท</div>
        <!-- summaryAll:: {{ JSON.stringify(summaryAll) }} -->
      </v-card-title>
      <form ref="form" id="editCompany" @submit="submit">
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                v-model="companyObject.nameTH"
                outlined
                label="ชื่อนิติบุคคล (Thai)"
                required
                :disabled="loading"
                :rules="rules.inputRule"
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                v-model="companyObject.nameEN"
                outlined
                label="ชื่อนิติบุคคล (EN)"
                required
                :disabled="loading"
                :rules="rules.inputRule"
                placeholder=" "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0 pt-0">
              <v-text-field
                v-model="companyObject.taxID"
                outlined
                label="เลขประจำตัวผู้เสียภาษี"
                required
                :disabled="loading"
                placeholder=" "
                :rules="rules.taxIDRule"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div class="row mx-0 image-upload">
                <div class="col">
                  <!-- companyObject.imageLogoShow -- {{  companyObject.imageLogoShow }}
                  companyObject.imageLogoUrl -- {{  companyObject.imageLogoUrl }} -->

                  <v-row v-if="companyObject.imageLogoUrl">
                    <v-col class="pt-1 pb-1">
                      <v-avatar color="#F5F5F5" size="60">
                        <img
                          v-if="
                            companyObject.imageLogoUrl &&
                            typeof companyObject.imageLogoUrl !== 'string'
                          "
                          :src="companyObject.imageLogoShow"
                          class="img-show"
                          :alt="companyObject.nameTH"
                        />
                        <img
                          v-if="
                            companyObject.imageLogoUrl &&
                            typeof companyObject.imageLogoUrl === 'string'
                          "
                          :srcset="
                            companyObject.imageLogoUrl +
                            '=c-w320, ' +
                            companyObject.imageLogoUrl +
                            '=c-w480 1.5x, ' +
                            companyObject.imageLogoUrl +
                            '=c-w640 2x'
                          "
                          :src="companyObject.imageLogoUrl + '=c-w640'"
                          :alt="companyObject.nameTH"
                        />
                      </v-avatar>
                      <v-progress-circular
                        v-if="
                          uploadLogoState && uploadCompanyStatus !== 'success'
                        "
                        :rotate="-90"
                        :size="60"
                        :width="2"
                        :value="uploadLogoState"
                        color="teal"
                        class="loading-img"
                      >
                      </v-progress-circular>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      :class="
                        companyObject.imageLogoUrl
                          ? 'text-upload pt-2 pb-2'
                          : 'text-upload pt-0 pb-2'
                      "
                    >
                      อัปโหลดภาพโลโก้บริษัท
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="text-center pt-0 pb-1">
                      <v-btn
                        color="#6ec39b"
                        class="btn-upload"
                        @click="$refs.inputUpload.click()"
                        :disabled="loading"
                        >เลือกภาพ</v-btn
                      >
                      <input
                        v-show="false"
                        ref="inputUpload"
                        type="file"
                        @change="onFileChanged"
                      />
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-title class="tw-pl-4">
          <div class="tw-text-xl tw-font-bold">ที่อยู่</div>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                outlined
                label="เลขที่"
                :value="addressObject.addressNo"
                @input="updateMessage"
                :disabled="loading"
                placeholder=" "
                required
                :rules="rules.inputRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                outlined
                label="อาคาร / ชั้น / ห้อง"
                v-model="addressObject.building"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="pb-1 pt-0">
              <v-text-field
                outlined
                label="ตรอก / ซอย"
                v-model="addressObject.alley"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-2 pt-0">
              <v-text-field
                outlined
                label="หมู่ที่"
                v-model="addressObject.village"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="pb-2 pt-0">
              <v-text-field
                outlined
                label="ถนน"
                v-model="addressObject.street"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pt-0 col-auto-complete">
              <div class="material-textfield">
                <ThailandAutoComplete
                  v-model="addressObject.postCode"
                  type="zipcode"
                  @select="select"
                  size="large"
                  color="#42b883"
                  placeholder=" "
                />
                <label>รหัสไปรษณีย์</label>
              </div>
              <div v-if="alertZipcode" class="input-address-error">
                กรุณากรอกข้อมูล
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="pt-0 col-auto-complete">
              <div class="material-textfield">
                <ThailandAutoComplete
                  v-model="addressObject.district"
                  type="amphoe"
                  @select="select"
                  color="#42b883"
                  size="large"
                  placeholder=" "
                />
                <label>เขต / อำเภอ</label>
              </div>
              <div v-if="alertAmphoe" class="input-address-error">
                กรุณากรอกข้อมูล
              </div>
            </v-col>
            <v-col cols="12" md="6" class="pt-0 col-auto-complete">
              <div class="material-textfield">
                <ThailandAutoComplete
                  v-model="addressObject.subDistrict"
                  type="district"
                  @select="select"
                  color="#42b883"
                  size="large"
                  placeholder=" "
                />
                <label>แขวง / ตำบล</label>
              </div>
              <div v-if="alertDistrict" class="input-address-error">
                กรุณากรอกข้อมูล
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="pt-0 col-auto-complete">
              <div class="material-textfield">
                <ThailandAutoComplete
                  v-model="addressObject.province"
                  type="province"
                  @select="select"
                  size="large"
                  color="#42b883"
                  placeholder=" "
                />
                <label>จังหวัด</label>
              </div>
              <div v-if="alertProvince" class="input-address-error">
                กรุณากรอกข้อมูล
              </div>
            </v-col>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="เบอร์โทรศัพท์สำนักงาน"
                v-model="companyObject.officeNumber"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="เบอร์โทรสาร"
                v-model="companyObject.faxNumber"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="เบอร์โทรศัพท์มือถือ"
                v-model="companyObject.phoneNumber"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="อีเมล"
                v-model="companyObject.email"
                type="email"
                :disabled="loading"
                required
                placeholder=" "
                :rules="rules.inputRule"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="Doc Pdf ID (ไม่จำเป็น)"
                v-model="companyObject.docPdfID"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="อีเมลที่ใช้ส่งเอกสารให้ลูกค้า (ไม่จำเป็น)"
                v-model="companyObject.emailSender"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="ชื่อผู้ส่งอีเมล (ไม่จำเป็น)"
                v-model="companyObject.emailSenderName"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="อีเมลโดเมน (ไม่จำเป็น)"
                v-model="companyObject.emailDomain"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="อีเมล API Key (ไม่จำเป็น)"
                v-model="companyObject.emailAPIKey"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="Prefix ใบเสร็จรับเงิน/ใบกำกับภาษี"
                v-model="prefixObectDetail.rt"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="Prefix ใบกำกับภาษีเต็มรูปแบบ"
                v-model="prefixObectDetail.tx"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="Prefix ใบเพี่มหนี้"
                v-model="prefixObectDetail.dr"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="Prefix ใบลดหนี้"
                v-model="prefixObectDetail.cr"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="Prefix ใบรับ"
                v-model="prefixObectDetail.re"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="Prefix ใบกำกับภาษีอย่างย่อ"
                v-model="prefixObectDetail.ab"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" class="pb-0 pt-0">
              <v-text-field
                outlined
                label="Prefix ใบแจ้งยกเลิก"
                v-model="prefixObectDetail.cl"
                :disabled="loading"
                placeholder=" "
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pb-0 pt-0">
            <v-select
              outlined
              v-model="companyObject.uploadTemplate2File"
              :items="[ { text: 'true', value: true }, { text: 'false', value: false } ]"
              label="Template Upload 2 Template"
              :disabled="loading"
              placeholder=" "
            ></v-select>
          </v-col>

          </v-row>
        </v-card-text>
      </form>
      <save-alert
        :status="uploadCompanyStatus"
        error-text="ไม่สามารถบันทึกได้ กรุณาลองใหม่อีกครั้ง"
        success-text="บันทึกสำเร็จ"
        v-if="uploadCompanyStatus"
      ></save-alert>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="black darken-1"
          text
          @click="onClickClose(false)"
          :disabled="loading"
          class="tw-tracking-normal tw-text-lg"
        >
          <v-icon left class="tw-text-2xl">mdi-close-circle-outline</v-icon>
          ยกเลิก
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          :disabled="loading"
          type="submit"
          form="editCompany"
          class="tw-tracking-normal tw-text-lg"
        >
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="green"
            style="margin-right: 10px"
          ></v-progress-circular>
          <v-icon left class="tw-text-2xl">mdi-content-save-outline</v-icon>
          บันทึก
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ThailandAutoComplete from "vue-thailand-address-autocomplete";
import SaveAlert from "../save-alert";
import { mapState } from "vuex";
import { checkImageSmall } from "../../../libs/validateImageUpload";
import fc from "@/firebaseConfig";

const _ = require("lodash");

let addressObjectDetail = {
  addressNo: "",
  building: "",
  village: "",
  alley: "",
  street: "",
  province: "",
  district: "",
  subDistrict: "",
  postCode: "",
};

let companyObjectDetail = {
  nameTH: "",
  nameEN: "",
  taxID: "",
  officeNumber: "",
  faxNumber: "",
  phoneNumber: "",
  email: "",
  docPdfID: "",
  imageLogoUrl: "",
  emailSender: "",
  emailSenderName: "",
  emailDomain: "",
  emailAPIKey: "",
  uploadTemplate2File: "",
};

let prefixObectDetail = {
  ab: [],
  tx: [],
  dr: [],
  cr: [],
  rt: [],
  re: [],
  cl: [],
};

export default {
  name: "DialogEditCompany",
  components: {
    ThailandAutoComplete,
    SaveAlert,
  },
  computed: mapState({
    isOpenModal: (state) => state.companies.isOpenModalCompany,
    companyIDModal: (state) => state.companies.companyIDModal,
    companyDetail: (state) => state.companies.companyDetail,
    uploadCompanyStatus: (state) => state.companies.uploadCompanyStatus,
    uploadLogoState: (state) => state.companies.uploadLogoState,
    loading: (state) => state.companies.loadingUpdate,
  }),
  data() {
    return {
      companyObject: _.cloneDeep(companyObjectDetail),
      addressObject: _.cloneDeep(addressObjectDetail),
      prefixObectDetail: _.cloneDeep(prefixObectDetail),
      alertProvince: false,
      alertAmphoe: false,
      alertDistrict: false,
      alertZipcode: false,
      isSetData: false,
      summaryAll: {},
      rules: {
        inputRule: [(v) => (!!v && this.isSetData) || "กรุณากรอกข้อมูล"],
        taxIDRule: [
          (v) => (!!v && this.isSetData) || "กรุณากรอกข้อมูล",
          (v) =>
            (v && v.length === 13) || "เลขประจำตัวผู้เสียภาษีควรมี 13 ตัวอักษร",
        ],
      },
    };
  },
  methods: {
    async getSummaryAll() {
      fc.companies
        .doc(this.companyIDModal)
        .collection("Summaries")
        .doc("all")
        .onSnapshot((allSummaries) => {
          // Use an arrow function here
          this.summaryAll = allSummaries.data();
          console.log("allSummaries:: ", allSummaries.data());
          console.log("this.summaryAll:: ", this.summaryAll);
        });
    },
    onFileChanged(event) {
      if (event) {
        checkImageSmall(event.target.files[0]).then((imageSmall) => {
          if (imageSmall) {
            alert("width lower 640 pixels. please select new image.");
          } else {
            let dataSet = _.cloneDeep(this.companyObject);
            dataSet.imageLogoUrl = event.target.files[0];
            dataSet.imageLogoShow = URL.createObjectURL(event.target.files[0]);
            this.companyObject = dataSet;
          }
        });
      }
    },
    select(address) {
      this.addressObject.subDistrict = address.district;
      this.addressObject.district = address.amphoe;
      this.addressObject.province = address.province;
      this.addressObject.postCode = address.zipcode;
    },
    submit: async function (e) {
      e.preventDefault();
      let company = _.cloneDeep(this.companyObject);
      _.set(company, "address", this.addressObject);
      const prefixes = {
        ab:
          typeof this.prefixObectDetail?.["ab"] == "string"
            ? this.stringToArray(this.prefixObectDetail["ab"])
            : this.prefixObectDetail["ab"],
        tx:
          typeof this.prefixObectDetail?.["tx"] == "string"
            ? this.stringToArray(this.prefixObectDetail["tx"])
            : this.prefixObectDetail["tx"],
        dr:
          typeof this.prefixObectDetail?.["dr"] == "string"
            ? this.stringToArray(this.prefixObectDetail["dr"])
            : this.prefixObectDetail["dr"],
        cr:
          typeof this.prefixObectDetail?.["cr"] == "string"
            ? this.stringToArray(this.prefixObectDetail["cr"])
            : this.prefixObectDetail["cr"],
        rt:
          typeof this.prefixObectDetail?.["rt"] == "string"
            ? this.stringToArray(this.prefixObectDetail["rt"])
            : this.prefixObectDetail["rt"],
        re:
          typeof this.prefixObectDetail?.["re"] == "string"
            ? this.stringToArray(this.prefixObectDetail["re"])
            : this.prefixObectDetail["re"],
        cl:
          typeof this.prefixObectDetail?.["cl"] == "string"
            ? this.stringToArray(this.prefixObectDetail["cl"])
            : this.prefixObectDetail["cl"],
      };
      await this.changeInputDisableAutoComplete(true);
      await this.$store.dispatch("companies/setUpdateCompanyEmpty");
      await this.$store.dispatch("companies/updateCompany", {
        companyID: this.companyIDModal,
        company: company,
        prefixes: prefixes,
      });

      console.log("prefixes:: ", prefixes);
    },
    changeInputDisableAutoComplete: async function (value) {
      let elements = await document.getElementsByClassName(
        "vth-addr-input vth-addr-input-size-large"
      );
      for (let i = 0; i < elements.length; i++) {
        if (value) elements[i].setAttribute("disabled", value);
        else elements[i].removeAttribute("disabled");
      }
    },
    setElement: async function () {
      let dialog = await document.getElementsByClassName(
        "v-dialog v-dialog--active"
      );
      if (dialog.length === 1) dialog[0].scrollTop = 0;
      let elements = await document.getElementsByClassName(
        "vth-addr-input vth-addr-input-size-large"
      );
      for (let i = 0; i < elements.length; i++) {
        elements[i].setAttribute("required", "required");
        if (i === 0) elements[i].setAttribute("id", "zipcode");
        if (i === 1) elements[i].setAttribute("id", "amphoe");
        if (i === 2) elements[i].setAttribute("id", "district");
        if (i === 3) elements[i].setAttribute("id", "province");
        elements[i].addEventListener("focusout", (event) => {
          if (event.target.value === "") {
            event.target.classList.add("input-error");
            event.target.parentNode.parentNode.nextElementSibling.classList.add(
              "text-color-error"
            );
            if (event.target.id === "province") {
              this.alertProvince = true;
            }
            if (event.target.id === "amphoe") {
              this.alertAmphoe = true;
            }
            if (event.target.id === "district") {
              this.alertDistrict = true;
            }
            if (event.target.id === "zipcode") {
              this.alertZipcode = true;
            }
          }
        });

        elements[i].addEventListener("keypress", () => {
          for (let i = 0; i < elements.length; i++) {
            elements[i].classList.remove("input-error");
            elements[
              i
            ].parentNode.parentNode.nextElementSibling.classList.remove(
              "text-color-error"
            );
            this.alertProvince = false;
            this.alertAmphoe = false;
            this.alertDistrict = false;
            this.alertZipcode = false;
          }
        });
      }
    },
    setDataCompany: function () {

      if (!this.companyDetail) return;
      let companyObjectData = _.cloneDeep(this.companyObject);
      for (let keysKey of _.keys(this.companyObject)) {
  let value = _.get(this.companyDetail, keysKey);

  if (value !== undefined && value !== null) { // รองรับ boolean (true/false) และค่าที่ไม่ใช่ null/undefined
    _.set(companyObjectData, keysKey, value);
  }
}

      this.companyObject = companyObjectData;

      let addressObjectData = _.cloneDeep(this.addressObject);
      for (let keysKey of _.keys(this.addressObject)) {
        if (
          this.companyDetail.address &&
          !_.isEmpty(this.companyDetail.address[keysKey])
        ) {
          _.set(
            addressObjectData,
            keysKey,
            _.get(this.companyDetail.address, keysKey)
          );
        }
      }
      this.addressObject = addressObjectData;
      this.isSetData = true;
    },
    updateMessage: function (test) {
      let data = _.cloneDeep(this.addressObject);
      _.set(data, "addressNo", test);
      this.addressObject = data;
    },
    onClickClose: function () {
      this.$store.dispatch("companies/setCloseModalCompany");
    },
    clearStateEmpty: function () {
      this.companyObject = _.cloneDeep(companyObjectDetail);
      this.addressObject = _.cloneDeep(addressObjectDetail);
      this.prefixObectDetail = _.cloneDeep(prefixObectDetail);
      this.alertProvince = false;
      this.alertAmphoe = false;
      this.alertDistrict = false;
      this.alertZipcode = false;
      this.isSetData = false;
    },
    stringToArray(_input) {
      if (!_input || _input.length == 0) return "";
      const result = _input.split(/,\s*/);
      const final = result.map((item) => item.trim());
      return final || final?.length > 0 ? final : "";
    },
    arrayToString(_input) {
      if (!_input || _input.length == 0) return;
      return _input.join(",");
    },
  },
  watch: {
    isOpenModal: {
      handler: async function () {
        if (this.isOpenModal) {
          await this.setElement();
          await this.$store.dispatch("companies/getCompany", {
            companyID: this.companyIDModal,
          });
          console.log("companyIDModal:: ", this.companyIDModal);
          await this.getSummaryAll({ companyID: this.companyIDModal });
        } else {
          this.clearStateEmpty();
          await this.$store.dispatch("companies/getList");
        }
      },
    },
    summaryAll: {
      handler: function () {
        this.prefixObectDetail = {
          ...prefixObectDetail,
          ...this.summaryAll?.prefixes,
        };

        console.log("this.prefixObectDetail:: ", this.prefixObectDetail);
      },
    },
    companyDetail: {
      handler: function () {
        this.setDataCompany();
      },
    },
    uploadCompanyStatus: {
      handler: function () {
        if (
          this.uploadCompanyStatus &&
          this.uploadCompanyStatus === "success"
        ) {
          this.changeInputDisableAutoComplete();
        }
      },
    },
  },
};
</script>

<style lang="scss">
.alert-detail {
  padding-left: 20px;
  padding-right: 20px;
}

.image-upload {
  max-width: 300px;
  min-height: 150px;
  border-radius: 10px;
  border: dashed 2px #b3b3b3;
  background-color: #f2f2f2;
  display: flex;
  align-items: center;
  text-align: center;
}

.button-edit {
  margin-right: 6px;
}

.btn-upload {
  color: white !important;
  font-size: 16px !important;
  font-weight: bold !important;
  border-radius: 10px;
  min-width: 200px !important;
}
.text-upload {
  font-size: 16px;
  font-weight: bold;
  color: #191919;
  text-align: center;
}
.img-show {
  object-fit: cover;
}

.material-textfield {
  position: relative;

  label {
    position: absolute;
    font-size: 12px;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    background-color: white;
    color: rgba(0, 0, 0, 0.6);
    padding: 0 0.3rem;
    margin: 0 0.5rem;
    transition: 0.1s ease-out;
    transform-origin: left top;
    pointer-events: none;
    line-height: 10px;

    &.text-color-error {
      color: #b71c1c !important;
    }
  }
  input {
    border-radius: 4px !important;
    border: 1px solid rgba(0, 0, 0, 0.4) !important;
    color: rgba(0, 0, 0, 0.6);
    transition: 0.5s ease-out;

    &:hover {
      border: 1px solid rgba(0, 0, 0, 0.87) !important;
    }

    &:focus {
      border: 2px solid #6ec39b !important;
    }

    &.input-error {
      border: 2px solid #b71c1c !important;
    }
  }

  .vth-addr-container:focus-within + label {
    color: #6ec39b;
  }

  input[type="text"] {
    min-height: 56px;
    line-height: 28px;
  }
}

.vth-addr-input-size-large[data-v-1f53c317] {
  font-size: 16px !important;
}

.col-auto-complete {
  margin-bottom: 1.3rem !important;
}

.vth-addr-input[data-v-1f53c317] {
  border-radius: 10px !important;
  line-height: unset !important;
  box-shadow: unset !important;
}

*[data-v-1f53c317] {
  font-family: unset !important;
}

.input-address-error {
  font-size: 12px;
  color: #b71c1c;
  line-height: 2px;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  margin-left: 13px;
}
.loading-img {
  position: absolute;
  left: 136px;
}

#edit-company {
  .v-input {
    border-radius: 10px;
  }
}
</style>
